export default __webpack_public_path__ + "static/media/kits.93201f9a.jpeg";